module.exports = __webpack_public_path__ + "static/media/07.bedf3b23.mp3";